// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CookieComponent} from './Cookie.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCookie = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CookieComponent/>
  </Icon>
));
